import { combineReducers, Reducer } from 'redux'

import { IState as CommonState, reducer as common } from './common'
import experiments from './experiments'
import {
  IState as FeaturedPageState,
  reducer as featuredPage
} from './featuredPage'
import { IState as HomePageState, reducer as homePage } from './homePage'
import landingPage from './landingPage'
import layout from './layout'
import { IState as IMarketingState, reducer as marketing } from './marketing'
import {
  enhancedRouterReducer,
  IState as LocationState
} from './reactRouterLocation'
import { IState as SearchPageState, reducer as searchPage } from './searchPage'
import user from './user'

export interface IRootState {
  common: CommonState
  homePage: HomePageState
  featuredPage: FeaturedPageState
  landingPage: any
  layout: any
  marketing: IMarketingState
  searchPage: SearchPageState
  user: any
  experiments: any
  router: LocationState
}

export const rootReducer = combineReducers<IRootState>({
  common,
  experiments,
  homePage,
  featuredPage,
  landingPage,
  layout,
  marketing,
  searchPage,
  user,
  router: enhancedRouterReducer
})
